import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'app-mapfre-custom-tooltip',
  templateUrl: './mapfre-custom-tooltip.component.html'
})
export class MapfreCustomTooltipComponent{
  @Output() showTooltip :EventEmitter<boolean>=new EventEmitter();
  @Input() description :string;
  @Input() tooltipTitle : string;
  @Input() toolTipImage :string;

  @HostListener('document:click', ['$event'])
  clickOutSide(event) {
    if(event && (event.pointerType === "mouse" || (event.pointerType === "touch")) && 
       !(event.target).closest(".tooltiptext") && !(event.target).closest(".tooltip-icon")){
        this.close();
    }
  }
  close(){
    this.showTooltip.emit(false);
  }
}